// Static data for the Control Tower

// ─── Geo lookup: port text → [lat, lng] ──────────────────────────────────────
export const GEO = {
    "Shanghai":[31.2304,121.4737],"Shanghai, CN":[31.2304,121.4737],
    "Beijing":[39.9042,116.4074],"Beijing, CN":[39.9042,116.4074],
    "Shenzhen":[22.5431,114.0579],"Shenzhen, CN":[22.5431,114.0579],
    "Guangzhou":[23.1291,113.2644],"Guangzhou, CN":[23.1291,113.2644],
    "Ningbo":[29.8683,121.544],"Ningbo, CN":[29.8683,121.544],
    "Tianjin":[39.0842,117.201],"Tianjin, CN":[39.0842,117.201],
    "Qingdao":[36.0671,120.3826],"Qingdao, CN":[36.0671,120.3826],
    "Haiphong":[20.8449,106.6881],"Haiphong, VN":[20.8449,106.6881],
    "Ho Chi Minh City":[10.8231,106.6297],"Ho Chi Minh City, VN":[10.8231,106.6297],
    "Mumbai":[19.076,72.8777],"Mumbai, IN":[19.076,72.8777],
    "Chennai":[13.0827,80.2707],"Chennai, IN":[13.0827,80.2707],
    "Kolkata":[22.5726,88.3639],"Kolkata, IN":[22.5726,88.3639],
    "Singapore":[1.3521,103.8198],"Singapore, SG":[1.3521,103.8198],
    "Laem Chabang":[13.0826,100.8794],"Laem Chabang, TH":[13.0826,100.8794],
    "Bangkok":[13.7563,100.5018],"Bangkok, TH":[13.7563,100.5018],
    "Jakarta":[-6.2088,106.8456],"Jakarta, ID":[-6.2088,106.8456],
    "Kuala Lumpur":[3.139,101.6869],"Kuala Lumpur, MY":[3.139,101.6869],
    "Port Klang":[3.0039,101.3846],"Port Klang, MY":[3.0039,101.3846],
    "Hong Kong":[22.3193,114.1694],"Hong Kong, HK":[22.3193,114.1694],
    "Tokyo":[35.6762,139.6503],"Tokyo, JP":[35.6762,139.6503],
    "Osaka":[34.6937,135.5023],"Osaka, JP":[34.6937,135.5023],
    "Yokohama":[35.4437,139.638],"Yokohama, JP":[35.4437,139.638],
    "Busan":[35.1796,129.0756],"Busan, KR":[35.1796,129.0756],
    "Taipei":[25.033,121.5654],"Taipei, TW":[25.033,121.5654],
    "Colombo":[6.9271,79.8612],"Colombo, LK":[6.9271,79.8612],
    "Dubai":[25.2048,55.2708],"Dubai, AE":[25.2048,55.2708],
    "Jeddah":[21.4858,39.1925],"Jeddah, SA":[21.4858,39.1925],
    "Rotterdam":[51.9225,4.4792],"Rotterdam, NL":[51.9225,4.4792],
    "Antwerp":[51.2213,4.4051],"Antwerp, BE":[51.2213,4.4051],
    "Hamburg":[53.5753,10.0153],"Hamburg, DE":[53.5753,10.0153],
    "Le Havre":[49.4944,0.1079],"Le Havre, FR":[49.4944,0.1079],
    "Felixstowe":[51.954,1.3509],"Felixstowe, GB":[51.954,1.3509],
    "Southampton":[50.9097,-1.4044],"Southampton, GB":[50.9097,-1.4044],
    "Los Angeles":[34.0522,-118.2437],"Los Angeles, US":[34.0522,-118.2437],
    "Long Beach":[33.7701,-118.1937],"Long Beach, US":[33.7701,-118.1937],
    "New York":[40.7128,-74.006],"New York, US":[40.7128,-74.006],
    "Savannah":[32.0809,-81.0912],"Savannah, US":[32.0809,-81.0912],
    "Vancouver":[49.2827,-123.1207],"Vancouver, CA":[49.2827,-123.1207],
    "Sydney":[-33.8688,151.2093],"Sydney, AU":[-33.8688,151.2093],
    "Melbourne":[-37.8136,144.9631],"Melbourne, AU":[-37.8136,144.9631],
    "Brisbane":[-27.4698,153.0251],"Brisbane, AU":[-27.4698,153.0251],
    "Fremantle":[-32.0569,115.744],"Fremantle, AU":[-32.0569,115.744],
    "Port Botany":[-33.9573,151.2277],"Port Botany, AU":[-33.9573,151.2277],
    "Auckland":[-36.8485,174.7633],"Auckland, NZ":[-36.8485,174.7633],
    // Ports / cities used by the Hasbro Excel reports
    "Yantian":[22.5694,114.2668],"Shekou":[22.4808,113.9116],"Nhava Sheva":[18.9497,72.9508],
    "Semarang":[-6.9667,110.4167],"Surabaya":[-7.2575,112.7521],
    "Perth":[-31.9523,115.8613],"Adelaide":[-34.9285,138.6007],"Hobart":[-42.8821,147.3272],
    "Canberra":[-35.2809,149.13],"Darwin":[-12.4634,130.8456],
};

// ─── Outbound (Australia) ─────────────────────────────────────────────────────
// Toll DC that ships the outbound orders — Warehouse 2, 5/35 Yarrunga Street, Prestons NSW 2170.
// Street-level position from OpenStreetMap (way 582051783), not the exact unit.
export const OUTBOUND_DC = { name: "Toll DC · Prestons NSW", address: "Warehouse 2, 5/35 Yarrunga Street, Prestons NSW 2170", coords: [-33.9379, 150.8636] };

// Delivery-site code prefix (e.g. BNE41, PER81) → city centre. City-level only; prefixes we
// can't place with confidence (SOU, BUR, BNY, TLG…) are left unmapped rather than guessed.
const AU_CITIES = {
    SYD: ["Sydney", [-33.8688, 151.2093]], MEL: ["Melbourne", [-37.8136, 144.9631]], BNE: ["Brisbane", [-27.4698, 153.0251]],
    PER: ["Perth", [-31.9523, 115.8613]], ADL: ["Adelaide", [-34.9285, 138.6007]], HBA: ["Hobart", [-42.8821, 147.3272]],
    CBR: ["Canberra", [-35.2809, 149.13]], DRW: ["Darwin", [-12.4634, 130.8456]], NEW: ["Newcastle", [-32.9283, 151.7817]],
    WOL: ["Wollongong", [-34.4278, 150.8931]], CAI: ["Cairns", [-16.9186, 145.7781]], ALB: ["Albury", [-36.0737, 146.9135]],
    ORA: ["Orange", [-33.2835, 149.1013]], TOO: ["Toowoomba", [-27.5598, 151.9507]],
};
const STATE_CITY = { NSW: "SYD", VIC: "MEL", QLD: "BNE", WA: "PER", SA: "ADL", TAS: "HBA", ACT: "CBR", NT: "DRW" };

/** Australian postcode → state (Australia Post ranges) */
export function stateFromPostcode(pc) {
    const n = parseInt(String(pc || "").trim(), 10);
    if (!Number.isFinite(n)) return null;
    if ((n >= 200 && n <= 299) || (n >= 2600 && n <= 2618) || (n >= 2900 && n <= 2920)) return "ACT";
    if (n >= 800 && n <= 999) return "NT";
    if (n >= 1000 && n <= 2999) return "NSW";
    if (n >= 3000 && n <= 3999) return "VIC";
    if (n >= 4000 && n <= 4999) return "QLD";
    if (n >= 5000 && n <= 5999) return "SA";
    if (n >= 6000 && n <= 6999) return "WA";
    if (n >= 7000 && n <= 7999) return "TAS";
    return null;
}

/**
 * Where an outbound shipment is heading, at city level: the city of its delivery site code,
 * else of its receiving state. The pin is the site's city — not the delivery suburb, which
 * can be far away (site PER88 delivers to Kununurra).
 */
export function outboundDestination({ site, state, suburb }) {
    const prefix = (site || "").slice(0, 3).toUpperCase();
    const bySite = AU_CITIES[prefix];
    const hit = bySite || AU_CITIES[STATE_CITY[(state || "").toUpperCase()]];
    if (!hit) return null;
    return {
        name: bySite && site ? `${hit[0]} · site ${site}` : `${hit[0]} (${state})`,
        detail: suburb ? `Delivering to ${suburb}` : null,
        city: hit[0], coords: hit[1],
    };
}

export function resolveCoords(text) {
    if (!text || text === "—") return null;
    const t = text.trim();
    if (GEO[t]) return GEO[t];
    const city = t.split(",")[0].trim();
    return GEO[city] || null;
}

// Fallback pins shown when DB has no shipment location data
export const FALLBACK_PINS = [
    { name:"Shanghai, CN",  color:"#F59E0B", count:2 },
    { name:"Singapore",     color:"#3B82F6", count:1 },
    { name:"Sydney, AU",    color:"#10B981", count:3 },
    { name:"Rotterdam, NL", color:"#10B981", count:1 },
    { name:"Los Angeles",   color:"#10B981", count:1 },
    { name:"Dubai, AE",     color:"#8B5CF6", count:1 },
];

// ─── Static sparkline data ────────────────────────────────────────────────────
const SP_BASE = {
    transit:[30,32,35,31,38,36,40,38,42,41,42],
    ontime:[85,87,89,88,90,91,89,90,91,90,90],
    delayed:[8,6,7,9,7,8,6,7,5,7,9],
    exception:[0,1,0,0,1,2,1,0,1,2,2],
    spend:[38,40,41,39,42,44,41,43,44,45,45],
    risk:[5,6,5,7,6,5,7,8,7,6,7],
};
export function mkSpark(key) {
    return (SP_BASE[key] || SP_BASE.transit).map((v, i) => ({ i, v }));
}

export const FREIGHT_TREND = [
    { d:"Jun 1",v:22000 },{ d:"Jun 8",v:28000 },{ d:"Jun 15",v:35000 },
    { d:"Jun 22",v:40000 },{ d:"Jun 29",v:45320 },
];

// ─── Incoterms reference data ─────────────────────────────────────────────────
// 9 stages: 0=Seller 1=Export 2=Alongside(load) 3=Port Load 4=Transit 5=Port Dest 6=Alongside(dest) 7=Last Mile 8=Buyer
export const INCOTERM_DEF = [
    { code:"EXW", name:"Ex Works",                    sellerEnd:0, riskAt:0, where:"Agreed Place",          tag:"sea+air", desc:"Minimum seller obligation. Buyer arranges all transport from seller's door." },
    { code:"FCA", name:"Free Carrier",                sellerEnd:1, riskAt:1, where:"Agreed Place",          tag:"sea+air", desc:"Seller delivers to named carrier. Risk transfers at first carrier handover." },
    { code:"FAS", name:"Free Alongside Ship",         sellerEnd:2, riskAt:2, where:"Port of Loading",       tag:"sea",     desc:"Seller delivers alongside vessel at port. Buyer loads and arranges freight." },
    { code:"FOB", name:"Free On Board",               sellerEnd:3, riskAt:3, where:"Port of Loading",       tag:"sea",     desc:"Seller loads onto vessel. Risk and cost pass when goods cross ship's rail." },
    { code:"CFR", name:"Cost & Freight",              sellerEnd:5, riskAt:3, where:"Port of Destination",   tag:"sea",     desc:"Seller pays freight to destination port. Risk transfers on loading — buyer insures." },
    { code:"CIF", name:"Cost, Insurance & Freight",   sellerEnd:5, riskAt:3, where:"Port of Destination",   tag:"sea",     desc:"Like CFR but seller also provides minimum insurance cover to destination port." },
    { code:"CPT", name:"Carriage Paid To",            sellerEnd:6, riskAt:1, where:"Place of Destination",  tag:"sea+air", desc:"Seller pays carriage to destination. Risk transfers at first carrier — buyer insures." },
    { code:"CIP", name:"Carrier & Insurance Paid To", sellerEnd:6, riskAt:1, where:"Place of Destination",  tag:"sea+air", desc:"Like CPT but seller provides insurance. Higher cover than CIF (Institute A)." },
    { code:"DPU", name:"Delivered at Place Unloaded", sellerEnd:7, riskAt:7, where:"Place of Destination",  tag:"sea+air", desc:"Seller delivers and unloads at named destination. Buyer pays import duties." },
    { code:"DAP", name:"Delivered at Place",          sellerEnd:7, riskAt:7, where:"Destination",           tag:"sea+air", desc:"Seller delivers to named place, ready to unload. Buyer unloads and clears customs." },
    { code:"DDP", name:"Delivered Duty Paid",         sellerEnd:8, riskAt:8, where:"Destination",           tag:"sea+air", desc:"Maximum seller obligation. Seller pays all freight, duties and taxes to buyer's door." },
];

export const STAGES_DEF = [
    { label:"Seller",       icon:"🏭" },
    { label:"1st Carrier",  icon:"🚛" },
    { label:"Alongside",    icon:"⚓" },
    { label:"Port Load",    icon:"🏗️" },
    { label:"Transit",      icon:"🚢" },
    { label:"Port Dest.",   icon:"🏗️" },
    { label:"Alongside",    icon:"⚓" },
    { label:"Last Mile",    icon:"🚛" },
    { label:"Buyer",        icon:"🏢" },
];

// ─── Shipment table search ────────────────────────────────────────────────────
// "search in" choices per report (keys match the backend's search scopes)
export const SEARCH_SCOPE_OPTIONS = {
    inbound:  [["all","All fields"],["container","Container"],["po","PO / Sales order"],["material","Material / SKU"],["booking","Booking / BL"]],
    outbound: [["all","All fields"],["connote","Connote / Shipment"],["po","PO"]],
};
export const SEARCH_PLACEHOLDER = {
    all:       "Search anything — PO, container, SKU, receiver…",
    container: "Container no. e.g. OOCU4912345",
    po:        "PO number(s), comma-separated",
    material:  "SKU or description, e.g. G19525L01",
    booking:   "Booking, CBL or HBL number",
    connote:   "Connote / shipment no. e.g. HSB0002926051",
};

// Dropdown filters per report: [query param, label]
export const FACET_FILTERS = {
    inbound: [["status","Status"],["plant","Plant"],["destination","Destination"],["origin","Origin"],
              ["carrier","Carrier"],["supplier","Supplier"],["mode","Mode"],["equipment","Equipment"]],
    outbound: [["status","Status"],["sheet","Type"],["state","State"]],
};
